module.exports = __webpack_public_path__ + "static/media/mobile-login.dac57216.svg";